export default __webpack_public_path__ + "static/media/ag.7a5b1ddc.svg";